import { Button } from "@geely/ui";
import { Plus } from 'lucide-react';
import { AdminLayout } from '@/app/components/AdminLayout';
import { PageHeader, PageLoading } from '@/app/components/shared';
import { TablePagination } from '@/app/components/shared/TablePagination';
import { StoresTable, StoreFormDialog } from './components';
import { useStoresData } from './hooks';

export function StoresPage() {
  const {
    stores,
    isLoading,
    paginationMeta,
    setPage,
    isDialogOpen,
    editingStore,
    handleOpenDialog,
    handleCloseDialog,
    handleSubmit,
    handleDelete,
  } = useStoresData();

  if (isLoading) {
    return <PageLoading message="Carregando lojas..." />;
  }

  return (
    <AdminLayout>
      <div className="space-y-6">
        <PageHeader
          title="Gerenciar Lojas"
          subtitle="Cadastre e gerencie as lojas do sistema"
          actions={
            <Button onClick={() => handleOpenDialog()}>
              <Plus className="size-4 mr-2" />
              Nova Loja
            </Button>
          }
        />

        <StoresTable
          stores={stores}
          onEdit={handleOpenDialog}
          onDelete={handleDelete}
        />

        {paginationMeta && (
          <TablePagination meta={paginationMeta} onPageChange={setPage} />
        )}

        <StoreFormDialog
          isOpen={isDialogOpen}
          editingStore={editingStore}
          onSubmit={handleSubmit}
          onClose={handleCloseDialog}
        />
      </div>
    </AdminLayout>
  );
}
